<div class="difficulty-dialog">
    <div class="mb-3 d-flex justify-content-end close"><img (click)="close()" class="cursor-pointer" src="assets/icons/close.svg" alt=""></div>
    <ng-container *ngIf="!same_route">
        <h1 class="text-center mt-3 text-c4 text-24-600-216">{{'Choose difficulty level'|translate}}</h1>
        <div [ngClass]="{'p-e-none': easy_status}" (click)="close('EASY')" class="text-center mt-5 level-item text-18-500-133 text-c4">
            {{('Easy' | translate)}}
        </div>
        <div [ngClass]="{'p-e-none': hard_status}" (click)="close('HARD')" class="text-center mt-4 level-item text-18-500-133 text-c4">
            {{('Hard' | translate)}}
        </div>
    </ng-container>
    <ng-container *ngIf="same_route">
        <h1 class="text-center mt-3 text-c4 text-16-400-150">
            {{"You've completed this level. To unlock next badges, click below to continue to next level." | translate}}</h1>
        <div [ngClass]="{'p-e-none': easy_status}" (click)="close('EASY')" class="text-center mt-5 level-item text-16-400-150 text-c4">
            {{ easy_status ? ('Easy level completed' | translate) : ('Proceed to easy level' | translate)}}
        </div>
        <div [ngClass]="{'p-e-none': hard_status}" (click)="close('HARD')" class="text-center mt-4 level-item text-16-400-150 text-c4">
            {{ hard_status ? ('Hard level completed' | translate) : ('Proceed to hard level' | translate)}}
        </div>
    </ng-container>
</div>
